<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-3">
                            <az-input
                                placeholder="Todas as unidades..."
                                icon="fa fa-building-o fa-fw"
                                type="select"
                                :optionsList="$util.unidades_com_tags(false, true)"
                                optionsData="id_unidade_operacao"
                                v-model="unidade" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                placeholder="Todos as gestões..."
                                icon="fas fa-layer-group fa-fw"
                                type="select"
                                service="estoque_grupo_locals.index"
                                optionsMode="aql"
                                optionsDisplay="search"
                                optionsData="id_estoque_grupo_local"
                                v-model="grupo" />
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-success" @click="incluir ()">
                                Incluir Local
                            </button>
                        </div>
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12">
                            <az-input icon="fas fa-search" v-model="search" />
                        </div>
                    </div>

                </div>

                

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum local de armazenagem identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Local'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" :class="dado.fl_disponivel ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }} 
                            <small class="text-muted ml-4" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                <i class="fa fa-building-o mr-2" aria-hidden="true"></i>
                                {{ dado.unidade_operacao.search }}
                            </small>
                        </a>
                        <span class="badge badge-secondary ml-3" v-if="dado.grupo">
                            {{ dado.grupo.search }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <a href="#" @click.prevent="acessos(dado)" class="btn btn-sm btn-outline-primary mr-1" title="Acesso">
                                <i class="fa-solid fa-user-lock"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.acessos && dado.acessos.length">{{ dado.acessos.length }}</span>
                            </a>

                            <a href="#" @click.prevent="acessos(dado)" class="btn btn-sm btn-outline-primary mr-1" title="Tipos de movimentação." v-if="false">
                                <i class="fa-solid fa-list-check"></i>
                            </a>

                            <a href="#" @click.prevent="toggle_disponivel(dado)" class="btn btn-sm btn-outline-primary">
                                <i class="fa-solid fa-door-open" v-if="dado.fl_disponivel" title="Local disponível para movimentações."></i>
                                <i class="fa-solid fa-door-closed" v-else title="Local fechado para movimentações."></i>
                            </a>

                            <a href="#" @click.prevent="limite_de_estoque(dado)" class="btn btn-sm btn-outline-primary ml-1" title="Limite de Estoque">
                                <i class="fa-solid fa-less-than-equal"></i>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_local ? '' : 'Novo' }}
                            Local de Armazenagem
                            <span class="badge badge-secondary ml-2" v-if="item.id_estoque_local">
                                #{{ item.id_estoque_local }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    label="Gestão"
                                    service="estoque_grupo_locals.index"
                                    optionsMode="aql"
                                    optionsDisplay="search"
                                    optionsData="id_estoque_grupo_local"
                                    :validate="validate"
                                    required
                                    v-model="item.id_estoque_grupo_local" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_estoque_local" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    :validate="validate"
                                    required
                                    v-model="item.id_unidade_operacao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Centro de Custo (Opcional)"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="lista_centros"
                                    optionsData="id_centro_custo"
                                    :edicao="item.id_unidade_operacao ? true : false"
                                    :validate="validate"
                                    v-model="item.id_centro_custo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 mt-2">
                                <az-input
                                    label="Tem estoque de vacina"
                                    type="checkbox-group"
                                    v-model="item.fl_vacina" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 my-2">
                                <az-input
                                    label="Permitir baixa direto a partir da solicitação"
                                    type="checkbox-group"
                                    v-model="item.fl_baixa_solic" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>

                        <div v-if="item.tipo_filtros">

                            <filtro-model
                                title="Filtro de Tipos de Movimentação"
                                class="my-3"
                                v-model="item.tipo_filtros"
                                :validate="validate"
                                :opcoes="lista_opcoes_filtro" />

                            <br><br><br><br><br>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueLocal" :id="item.id_estoque_local" v-if="item && item.id_estoque_local" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_local ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <estoque-item-limite ref="limite" />
        <edicao-acessos ref="acessos" @refresh="load()" />
        

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EstoqueItemLimite from './EstoqueItemLimite.vue';
import EdicaoAcessos from '../../cadastros/shared/EdicaoAcessos.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
            grupo: "", 
            novo_tipo: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EstoqueItemLimite,
        EdicaoAcessos,
        FiltroModel,
    },

    computed: { 
        lista_centros: function () { 
            if ( !this.item || !this.item.id_unidade_operacao ) 
                return [];

            return this.$util.centros_usuario(this.item.id_unidade_operacao);
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [
                {id: 'App\\azure\\estoqueTipoMovimentacao', search:'Tipo', service: 'estoque_tipo_movimentacaos.index'},
            ];

            return opcoes;
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => !this.unidade || item.id_unidade_operacao == this.unidade)
                .filter(item => !this.grupo || item.id_estoque_grupo_local == this.grupo)
                .filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\estoqueLocal', 
              item.id_estoque_local,
              item.search, 
            );
        },

        limite_de_estoque (item) { 
            this.$refs.limite.abrir(item, null, item.id_estoque_local);
        },

        toggle_disponivel (item) { 
            item.fl_disponivel = !item.fl_disponivel;

            this.$util.atualizar(this, { 
                service: 'estoque_locals',
                func: 'store',
                dados: item,
                toast: true, 
            });
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_estoque_local: null, 
                st_estoque_local: "",
                st_observacao: "",  
                fl_disponivel: true,
                fl_ativo: true,
                id_unidade_operacao: this.unidade ? this.unidade : ( 
                    this.$store.state.unidade.unidade_operacaos.length == 1 ?
                    this.$store.state.unidade.unidade_operacaos.id_unidade_operacao : null
                ),
                tipo_filtros: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'estoque_locals.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    }
                },
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: 'estoque_locals.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                $('#edicaoModal').modal('hide');
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });

                                this.$util.resync(this, 'estoque_locals.index');
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'estoque_locals.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        this.$util.resync(this, 'estoque_locals.index');
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Local de Armazenagem", path: "/suprimentos/local" }
        ]);

        this.load ();
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>